import { supabase } from './supabase';

export async function deleteMissingGpsPhoto(photoId: string): Promise<void> {
  if (!supabase) throw new Error('Supabase client not initialized');

  const { error } = await supabase.functions.invoke('delete-photo', {
    body: { photoId },
  });

  if (error) {
    throw new Error('사진 삭제에 실패했습니다.');
  }
}
